import { IEditableRule } from './RuleRows'

// why: the picker disables an already-used scope, but a rule set loaded with
// a pre-existing duplicate (e.g. bad data from before this UI) reaches here
// unblocked. The DB's one-live-row index would reject the whole save with no
// per-row message, so this catches it earlier with one the user can act on.
const validateRules = (rules: IEditableRule[]): string | null => {
  const seen = new Set<number | null>()

  for (const rule of rules) {
    if (!rule.value || rule.value.trim() === '') {
      return 'Every rule needs a percentage'
    }
    if (isNaN(parseFloat(rule.value))) {
      return 'Please enter valid numeric values for every rule'
    }
    if (seen.has(rule.locationGroupId)) {
      return 'Two rules cannot apply to the same locations'
    }
    seen.add(rule.locationGroupId)
  }

  return null
}

export default validateRules
